<template>
  <event-today v-if="filename === 'EventToday'"></event-today>
  <dashboard v-else-if="filename === 'dashboard'"/>
  <error404 v-else></error404>
</template>

<script>
import Error404 from '@/views/pages/Error404'
import EventToday from '@/views/pages/custom/EventToday'

export default {
  name : 'pages',
  components : {
    Error404, EventToday,
    Dashboard: () => import("@/views/Dashboard.vue"),
  },
  data () {
    return {
      filename : ''
    }
  },
  computed: {
    myInfo () {
      return this.$store.state.auth.userInfo
    },
  },
  created () {
    this.filename = this.$route.params.custom
  }
}
</script>

<style scoped>

</style>
